import axiosInstance from "../../axios";
import urls from "../../Utils/urls";

// Derived from an existing /api/v1 constant, like services/mfa/mfaApi.js, so urls.js needs no edit.
const API_V1 = urls.admin.getAuthToken.replace(/\/auth\/get_auth_token$/, "");

// docs/specs/password-reset-stepup.md. Bodies carry a password or a code: never log a request or a response here.
// Errors propagate; callers map them with describeMfaError.

// Pre-login Forgot Password. `flow` is node's sealed flow, passed back as it came.
export const startForgot = async ({ email }) =>
  (await axiosInstance.post(`${API_V1}/auth/password/forgot/start`, { email })).data;

export const verifyForgot = async ({ flow, code }) =>
  (await axiosInstance.post(`${API_V1}/auth/password/forgot/verify`, { flow, code })).data;

export const resetForgot = async ({ flow, newPassword }) =>
  (await axiosInstance.post(`${API_V1}/auth/password/forgot/reset`, { flow, new_password: newPassword })).data;

// Signed-in Change Password: the step-up token is the proof; the shared interceptor supplies the session JWT.
export const changePassword = async ({ stepUpToken, newPassword }) =>
  (await axiosInstance.post(`${API_V1}/mfa/password`, { step_up_token: stepUpToken, new_password: newPassword })).data;
